<div class="multi-choice-container">
  @for (option of options; track option.value; let i = $index) {
    <div
      class="multi-choice-item"
      (click)="onClickOption(option)"
      (mouseover)="onHoverItem(i)"
      [class.selected]="i === selectedIndex && !option.disabled"
      [class.disabled]="!!option.disabled || notAllowedTooltip"
    >
      <div class="wrapper-item-text">
        <div class="item-text-line" [attr.data-cy]="'item-text-line-' + option.text">
          @if (option.icon) {
            <u-icon class="item-icon" [model]="option.icon"></u-icon>
          }
          <div class="item-text">{{ option.text }}</div>
        </div>
        <div class="item-description">{{ option.description }}</div>
      </div>
      @if (option.badge) {
        <u-badge [text]="option.badge.text" [typeElement]="option.badge.style"></u-badge>
      }
      @if (option.disabled && option.warningText) {
        <div class="warning-icon" [escape]="false" [pTooltip]="option.warningText" tooltipPosition="left" tooltipStyleClass="u-tooltip">
          <div class="icon">!</div>
        </div>
      }
    </div>
  }
</div>
